import * as React from 'react';
import styled from '@emotion/styled';
import image from '../../images/trs.png';
import { Components } from '../App/App';

interface HeaderProps {
  selected: Components;
  handleComponentSelect: any;
};

const StyledHeader = styled('header')`
  flex-shrink: 0;
  padding: 1rem 3rem;
  background: rgb(62,62,62);
  color: white;

  @media (max-width: 1024px) {
    padding: 1rem;
  }

  @media (max-width: 445px) {
    text-align: center;

    ul {
      display: block;
      padding: 0;
    }
  }
`;

const CroppedImage = styled('div')`
  overflow: hidden;
  display: inline-block;
  width: 9.0625rem;
  height: 3.75rem;

  > img {
    margin: -6rem 0 0 -2.85rem;
    width: 250px;
  }
`;

const NavigationList = styled('ul')`
  display: inline-block;
  list-style-type: none;
  margin: 1.375rem 0;
  vertical-align: top;

  li {
    display: inline-block;
    margin: 0 0.5rem;
  }

  a {
    color: white;
    
    li {
      text-decoration: none;
    }

    &:hover li {
      text-decoration: underline;
    }

    &:visited {
      color: white;
    }
  }
`;

const SelectedLine = styled('li')`
  font-weight: bold;
`;

class Header extends React.PureComponent<HeaderProps, {}> {
  render () {
    return (
      <StyledHeader>
        <a href="/" title="Return to the Australian Sporting Innovations homepage">
          <CroppedImage>
            <img src={image} />
          </CroppedImage>
        </a>
        <NavigationList>
          {
            (this.props.selected === 'Intro' && <SelectedLine>Introduction</SelectedLine>)
            || <a
                href="#"
                onClick={() => this.props.handleComponentSelect('Intro')}
              >
                <li>Introduction</li>
              </a>
          }
          {
            (this.props.selected === 'Manual' && <SelectedLine>Manual</SelectedLine>)
            || <a
                href="#"
                onClick={() => this.props.handleComponentSelect('Manual')}  
              >
                <li>Manual</li>
              </a>
          }
          {
            (this.props.selected === 'DrillSelector' && <SelectedLine>Drills</SelectedLine>)
            || <a
                href="#"
                onClick={() => this.props.handleComponentSelect('DrillSelector')}
              >
                <li>Drills</li>
              </a>
          }
        </NavigationList>
      </StyledHeader>
    );
  }
}

export default Header;
